/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, total: NonNullable<unknown> }} Mobile_Page_X_Of_YInputs */

const en_mobile_page_x_of_y = /** @type {(inputs: Mobile_Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.total}`)
};

const es_mobile_page_x_of_y = /** @type {(inputs: Mobile_Page_X_Of_YInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page} de ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Page {page} of {total}" |
*
* @param {Mobile_Page_X_Of_YInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_page_x_of_y = /** @type {((inputs: Mobile_Page_X_Of_YInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Page_X_Of_YInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_page_x_of_y(inputs)
	return en_mobile_page_x_of_y(inputs)
});